import { MercadoPagoConfig } from "./mercadoPagoService";

// Configuración centralizada de MercadoPago
export const MERCADO_PAGO_CONFIG: MercadoPagoConfig = {
  publicKey: "APP_USR-54dbf828-3621-44e3-84de-8f414bf8adae",
  locale: "es-AR",
};

// Configuraciones por ambiente (opcional)
export const getMercadoPagoConfig = (deviceId?: string): MercadoPagoConfig => {
  const isProduction = process.env.NODE_ENV === "production";
  
  const baseConfig = {
    publicKey: isProduction 
      ? (process.env.REACT_APP_MERCADO_PAGO_PUBLIC_KEY || MERCADO_PAGO_CONFIG.publicKey)
      : MERCADO_PAGO_CONFIG.publicKey,
    locale: "es-AR",
    ...(deviceId && { deviceId }),
  };
  
  return baseConfig;
};
